// extracted by mini-css-extract-plugin
export var attachment = "_pr-a";
export var emailContainer = "_pr-4";
export var emailContentPaddedContainer = "_pr-b";
export var emailHeader = "_pr-6";
export var emailIframe = "_pr-3";
export var emailInfoIcon = "_pr-9";
export var emailShortenedSummary = "_pr-e";
export var infoDropdown = "_pr-0";
export var infoRowBoundedContent = "_pr-d";
export var internal = "_pr-5";
export var merchant = "_pr-8";
export var messageInputContainer = "_pr-h";
export var normal = "_pr-7";
export var replyCard = "_pr-f";
export var subtleButton = "_pr-1";
export var subtleButtonIconContainer = "_pr-2";
export var toggleViewRepliesButton = "_pr-c";
export var wrappingText = "_pr-g";